import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
// import * as moment from "moment";
// Material
// import Typography from "@material-ui/core/Typography";
// import TextField from "@material-ui/core/TextField";
// Custom Hooks
import useDynamicHotelData from "../../../CustomHooks/useDynamicHotelData";
import useWorkingInfo from "../../../CustomHooks/useWorkingInfo";
// Styles
import useStyles from "./DeliveryTime.style.js";
// Constans
import {
  // DELIVERY_PICKUP_TYPES,
  ORDER_TYPES,
} from "../../../utils/Constants";
import DateSlotPicker from "../DateSlotPicker";
import TimePicker from "../TimePicker";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import { OutlinedInput } from "@material-ui/core";
import CheckBox from "../../Controls/Checkbox/CheckBox";
// import { showSnackbarAction } from "../../../store/Snackbar/SnackbarAction";
// import { convertToMoment } from "../../../utils/TimeUtils";
import { generateDateSlots } from "../../../utils/utils";
import Btn from "../../Controls/Button/Button";
import Modal from "../../Material/Modal/Modal";
import TableListing from "../../TableListing/TableListing";
import {
  clearTableSelection,
  clearTipAmount,
} from "../../../store/Cart/CartActions";
import { ENABLE_TABLE_PRE_BOOKING_AND_ORDER } from "../../../config/app-config";
import useCheckoutForm from "../../../CustomHooks/useCheckoutForm.js";
import { resetWallet } from "../../../store/Profile/ProfileActions.js";
import useWalletPoints from "../../../CustomHooks/useWalletPoints.js";

const DeliveryTime = ({
  value,
  orderType,
  onSelect = () => {},
  onOrderTypeSelect = () => {},
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  // const [deliveryType, setDeliveryType] = useState(value.deliveryType || "");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [dateSlots, setDateSlots] = useState([]);
  const { formValues, setFormValues } = useCheckoutForm();

  // const { getDeliveryPickupTypes } = useDynamicHotelData();
  const { defaultStartTime } = useWorkingInfo();
  const {
    getDeliveryIntervalSlots,
    getTodayDeliveryIntervalSlots,
    isAsapAvailable,
    // getAvailableDays,
    isMultipleOrderType,
    getOrderTypes,
  } = useDynamicHotelData();
  const { hotel } = useSelector((state) => state.hotel);
  const { selectedTable, checkoutDetails } = useSelector((state) => state.cart);
  const [typeOfOrder, setTypeOfOrder] = useState(checkoutDetails?.deliveryType);
  const [dateSlotsError, setDateSlotsError] = useState(false);
  const [showModal, toggleModal] = useState(false);
  const [isCheckBoxDisabled, setIsCheckBoxDisabled] = useState(false);
  const { resetWalletProducts } = useWalletPoints();
  const [newChange, setNewChange] = useState(false);
  const [typeChanges, setTypeChanges] = useState(false);

  const generateDatePickerSlots = () => {
    let orderTypeValue = orderType;
    if (orderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING) {
      orderTypeValue = ORDER_TYPES.OPENING;
    }
    const dates = generateDateSlots(hotel, orderTypeValue) || [];
    setDateSlots(dates);
    if (!dates || !dates?.length) {
      setDateSlotsError(true);
    }
  };

  // console.log("isMultipleOrderType", isMultipleOrderType);
  // console.log("new changeeeeee", newChange);
  const onSelectDataAndTime = ({ value, typeOfOrder } = {}, type) => {
    if (!value) return;
    // Set typeOfOrder if provided (e.g. when a slot object is passed in
    // from TimePicker on user-selection, the slot's own typeOfOrder —
    // "ASAP" or "SCHEDULED" — is the source of truth).
    if (typeOfOrder) {
      setTypeOfOrder(typeOfOrder);
    }

    // The isToday/isAsapAvailable override only makes sense for the
    // DATE selection branch: `value` for type==="date" is the formatted
    // date string ("May 19, 2026"), which `new Date()` can parse. For
    // type==="time", `value` is a clock time like "07:51 am" —
    // `new Date("07:51 am")` returns Invalid Date, isToday becomes
    // false, and we'd otherwise force typeOfOrder to "SCHEDULED" even
    // when the user just picked the ASAP slot. That contradicted the
    // explicit `typeOfOrder` set above and made checkout validation fail
    // with "Please select order time" because the dispatched cart entry
    // looked like a SCHEDULED order for a time at/below now.
    if (type === "date") {
      const today = new Date();
      const selectedDate = new Date(value);
      const isToday = selectedDate.toDateString() === today.toDateString();
      // The "today → default to ASAP" override must only apply to an
      // EXPLICIT user date change (`newChange === true`), not the initial
      // auto-sync that DateSlotPicker performs from cart.deliveryTime on
      // mount. On that auto-sync `newChange` is still false — forcing
      // ASAP there would silently overwrite a SCHEDULED choice the user
      // made in the order-time popup (cart.deliveryType="SCHEDULED"),
      // making the checkout payload go out as ASAP. Preserving the
      // current typeOfOrder on auto-sync keeps the popup's selection
      // intact; a genuine user date-switch to today still defaults ASAP.
      if (isToday && isAsapAvailable && newChange) {
        setTypeOfOrder("ASAP");
      } else if (!isToday) {
        setTypeOfOrder("SCHEDULED");
      }
    }

    // When a date is selected
    if (type === "date") {
      // Allow the future-slot auto-select effect below to re-fire for
      // the newly selected date (without this, picking tomorrow keeps
      // showing today's first slot because the effect's ref is still
      // locked from a prior date selection).
      hasAutoSelectedFutureSlot.current = false;
      const todayDate = new Date();
      const selectedDateObj = new Date(value);
      const isTodaySelected =
        selectedDateObj.toDateString() === todayDate.toDateString();
      setDate((prevDate) => {
        if (prevDate) {
          if (prevDate !== value) {
            setNewChange(true); // Trigger newChange only if the date is different
          }
        }

        // Pick the time slot for the newly selected date.
        // When switching to today with ASAP available, prefer the ASAP
        // entry. `getAvailableTimeSlotsForDate` filters by `typeOfOrder`,
        // which is still the stale "SCHEDULED" from the previous
        // (tomorrow) selection at this synchronous point — the
        // `setTypeOfOrder("ASAP")` above hasn't applied yet — so it
        // would otherwise drop the ASAP entry and fall back to today's
        // first SCHEDULED grid slot.
        let firstTimeSlot;
        if (isTodaySelected && isAsapAvailable) {
          const asapSlot = getTodayDeliveryIntervalSlots.find(
            (s) => s.typeOfOrder === "ASAP"
          );
          firstTimeSlot = asapSlot?.value;
        }
        if (!firstTimeSlot) {
          const availableTimeSlots = getAvailableTimeSlotsForDate(value);
          firstTimeSlot =
            availableTimeSlots && availableTimeSlots.length > 0
              ? availableTimeSlots[0].value
              : undefined;
        }
        if (firstTimeSlot && newChange) {
          setTime((prevTime) => {
            if (prevTime !== firstTimeSlot) {
              setNewChange(true); // Trigger newChange if time changes
            }
            return firstTimeSlot; // Set the first available time
          });
        }

        return value; // Set the new date
      });
    }

    // When a time is selected manually
    if (type === "time") {
      setTime((prevTime) => {
        if (prevTime !== value) {
          setNewChange(true); // Trigger newChange only if the time is different
        }
        return value;
      });
    }
  };

  const getAvailableTimeSlotsForDate = (selectedDate) => {
    // Get the time slots for today or another date based on the selected date
    const availableSlots = moment(selectedDate).isSame(moment(), "date")
      ? getTodayDeliveryIntervalSlots
      : getDeliveryIntervalSlots;

    // Add condition to filter for "SCHEDULED" time slots if orderTimeType is "SCHEDULED"
    if (typeOfOrder === "SCHEDULED") {
      return availableSlots.filter((slot) => slot.typeOfOrder === "SCHEDULED");
    }

    return availableSlots; // Return all available slots if not filtered
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Skip the first render
    } else if (newChange || !isMultipleOrderType) {
      // Don't dispatch until BOTH date and time are set. When date is
      // auto-selected before TimePicker populates time, `moment(date)`
      // parses to midnight-of-that-day — already in the past — and gets
      // pushed to cart.deliveryTime, causing "Please select order time"
      // at checkout validation.
      if (!date || !time) return;
      // When the user picks ASAP, anchor the deliveryTime to TODAY
      // regardless of which date is currently displayed in the picker.
      // In a "shop closes within buffer" window, the date picker
      // auto-jumps to tomorrow (today has no SCHEDULED slots), but ASAP
      // is by definition today's now+buffer. Combining the ASAP clock
      // string with tomorrow's calendar date would otherwise push the
      // cart to "tomorrow + ASAP time", which then breaks the
      // place-order flow and shows tomorrow's first slot pre-selected
      // on subsequent renders.
      const dateStr = typeOfOrder === "ASAP" ? moment().format("LL") : date;
      const timeString = `${dateStr} ${time}`;
      const dTime = moment(timeString).toISOString();

      onSelect(typeOfOrder || "SCHEDULED", dTime);

      setNewChange(false); // Reset newChange after processing
    }
  }, [date, time, typeOfOrder, newChange, isMultipleOrderType]);
  // console.log("hotel?.deliveryAvailable", hotel?.deliveryAvailable);
  // console.log("hotel?.pickupAvailable", hotel?.pickupAvailable);

  useEffect(() => {
    if (hotel) {
      if (hotel?.is_preorder === 0) {
        if (
          hotel?.deliveryAvailable === false ||
          hotel?.pickupAvailable === false
        ) {
          setIsCheckBoxDisabled(true);
        } else {
          setIsCheckBoxDisabled(false);
        }
      } else {
        setIsCheckBoxDisabled(false);
      }
    }
  }, [hotel]);

  const isFirstRender = useRef(true); // Add this ref to track the first render

  // Auto-select the first scheduled slot whenever the user picks a
  // future date. Mirrors the modal's auto-select-future-slot effect.
  // Necessary because:
  //  - The inline setTime inside onSelectDataAndTime reads
  //    getDeliveryIntervalSlots at click time, when the slot list still
  //    reflects the PREVIOUS date (cart.deliveryTime hasn't propagated
  //    yet). So it sets time to the previous date's first slot.
  //  - The dispatch useEffect then pushes (date=tomorrow, time=stale)
  //    to cart. After that, getDeliveryIntervalSlots recomputes for
  //    tomorrow, but without this effect, nothing re-syncs the picker
  //    to tomorrow's actual first slot.
  // The `slotsAreForSelectedDate` guard ensures we only commit once the
  // slot list reflects the user's selected date (prevents firing with
  // stale today's-slots and locking the ref).
  const hasAutoSelectedFutureSlot = useRef(false);
  useEffect(() => {
    const isFutureDate = date && !moment(date).isSame(moment(), "date");
    const slotsAreForSelectedDate =
      !!formValues?.deliveryTime &&
      !!date &&
      moment(formValues.deliveryTime).isSame(moment(date), "date");
    if (
      typeOfOrder === "SCHEDULED" &&
      date &&
      isFutureDate &&
      getDeliveryIntervalSlots?.length > 0 &&
      !hasAutoSelectedFutureSlot.current &&
      slotsAreForSelectedDate
    ) {
      const scheduledSlots = getDeliveryIntervalSlots.filter(
        (s) => s.typeOfOrder === "SCHEDULED"
      );
      if (scheduledSlots.length > 0) {
        hasAutoSelectedFutureSlot.current = true;
        // Prefer the user's existing cart.deliveryTime when it matches
        // one of the scheduled slots for the selected date. This
        // preserves an intermediate slot the user already picked in the
        // modal (e.g. tomorrow @ 6:00 PM) instead of clobbering it with
        // slots[0] (= tomorrow @ first slot) on checkout mount. Falls
        // back to the first scheduled slot only when cart's time
        // doesn't fit the date's grid (e.g. after the user manually
        // changes date in checkout and the previous time isn't in the
        // new day's slot list).
        const cartTimeFormatted = moment(formValues.deliveryTime)
          .format("hh:mm a")
          .toLowerCase();
        const cartMatch = scheduledSlots.find(
          (s) => s.value === cartTimeFormatted
        );
        const target = cartMatch || scheduledSlots[0];
        setTime(target.value);
        setNewChange(true);
      }
    }
  }, [
    getDeliveryIntervalSlots,
    date,
    typeOfOrder,
    formValues?.deliveryTime,
  ]);

  useEffect(() => {
    // If isMultipleOrderType is false or orderType changes, set the first available time as the default
    if (!isMultipleOrderType && isFirstRender.current) {
      const slots =
        moment(value.deliveryTime).isSame(moment(), "date") &&
        getTodayDeliveryIntervalSlots.length > 0
          ? getTodayDeliveryIntervalSlots
          : getDeliveryIntervalSlots;
      if (slots.length > 0) {
        // Set the first date and time slot if they are available
        const firstSlot = slots[0]; // Assuming the slots have a consistent structure
        const firstTime = firstSlot?.value; // Adjust based on your slot structure
        const currentDate = moment().format("YYYY-MM-DD"); // Assuming you want to use today's date as default
        setDate(currentDate);
        setTime(firstTime);
      }

      isFirstRender.current = false;
    }
  }, [
    isMultipleOrderType,
    getTodayDeliveryIntervalSlots,
    getDeliveryIntervalSlots,
    value.deliveryTime,
    orderType,
  ]);

  useEffect(() => {
    if (hotel || formValues?.orderType) {
      generateDatePickerSlots();
    }
  }, [hotel, formValues?.orderType]);

  const isScheduledAvailable = useMemo(() => {
    return (
      (Array.isArray(getTodayDeliveryIntervalSlots) &&
        getTodayDeliveryIntervalSlots.length > 0) ||
      (Array.isArray(getDeliveryIntervalSlots) &&
        getDeliveryIntervalSlots.length > 0)
    );
  }, [getTodayDeliveryIntervalSlots, getDeliveryIntervalSlots]);

  useEffect(() => {
    if (formValues?.orderType && getOrderTypes?.length > 0) {
      const timeoutId = setTimeout(() => {
        // Find the current order type in the getOrderTypes array
        const currentOrderType = formValues?.orderType;

        // Find the type to switch to, based on the current orderType
        const nextOrderType = getOrderTypes.find(
          (typeObj) => typeObj.type !== currentOrderType
        );

        // If there's a valid type to switch to, update the orderType
        if (!isAsapAvailable && !isScheduledAvailable && nextOrderType) {
          onOrderTypeSelect(nextOrderType.type);
        }
      }, 1000); // 2-second timeout

      // Cleanup function to clear the timeout if dependencies change
      return () => clearTimeout(timeoutId);
    }
  }, [
    formValues?.orderType,
    getOrderTypes,
    isAsapAvailable,
    isScheduledAvailable,
  ]);

  const onClick = () => {
    setNewChange(true);
  };

  // const selectDeliveryTime = (type) => {
  //   setDeliveryType(type);
  //   if (type === DELIVERY_PICKUP_TYPES.ASAP) {
  //     const dTime = defaultStartTime;
  //     onSelect(type, dTime);
  //   }
  // };
  // console.log("hotelllll", hotel)

  useEffect(() => {
    if (dateSlots?.length === 0) {
      setDate(null);
    }
  }, [dateSlots]);

  useEffect(() => {
    if (!orderType) {
      return;
    }

    if (orderType !== ORDER_TYPES.TABLE_BOOKING_AND_ORDERING) {
      dispatch(clearTableSelection());
    }
  }, [orderType]);

  // if (dateSlots?.length === 0) {
  //   return (
  //     <div className={clsx(classes.root)}>
  //       <div className={clsx(classes.container)}>
  //         <p>
  //           {!dateSlotsError
  //             ? "Loading time slots...."
  //             : "Delivery time finished"}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  // console.log("getOrderTypes", getOrderTypes);

  // const isAsapUnAvailable = (o) => {
  //   return o.type === "ASAP" && !isAsapAvailable;
  // };

  // const isPreOrderAvailable = (o) => {
  //   return o.type === "SCHEDULED" && hotel.is_preorder === 0;
  // };

  return (
    <div id="checkout-deliveryPickupTypeForm" className={clsx(classes.root)}>
      <div>
        <table className={`w-100 ${classes.borderTable}`}>
          <tbody>
            <tr>
              <td colSpan="2">
                <div className="row m-0">
                  {getOrderTypes?.map((o, i) => (
                    <div key={i} className={`col ${classes.checkBoxTd}`}>
                      <CheckBox
                        isFromCheckout={true}
                        text={o.title}
                        checked={formValues?.orderType === o.type}
                        disabled={
                          (o.type === "DELIVERY" &&
                            hotel?.is_preorder === 0 &&
                            !hotel?.deliveryAvailable) ||
                          (o.type === "PICKUP" &&
                            hotel?.is_preorder === 0 &&
                            !hotel?.pickupAvailable)
                        }
                        onChange={(e) => {
                          e.stopPropagation();
                          onOrderTypeSelect(o.type);
                          dispatch(resetWallet());
                          resetWalletProducts(2);
                          setTypeChanges(true);
                          dispatch(clearTipAmount());
                        }}
                        classes={{
                          checkBoxContainer: classes.checkBoxContainer,
                        }}
                      />
                    </div>
                  ))}
                </div>
              </td>
            </tr>
            {ENABLE_TABLE_PRE_BOOKING_AND_ORDER && (
              <tr>
                <td
                  colSpan={
                    orderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING ? 1 : 2
                  }
                >
                  <div
                    className={`${classes.checkBoxTd} ${
                      orderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING
                        ? "border-0"
                        : ""
                    }`}
                  >
                    <CheckBox
                      text={"Table booking"}
                      checked={
                        orderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING
                      }
                      isFromCheckout={true}
                      onChange={(e) => {
                        e.stopPropagation();
                        onOrderTypeSelect(
                          ORDER_TYPES.TABLE_BOOKING_AND_ORDERING
                        );
                      }}
                      classes={{
                        checkBoxContainer: classes.checkBoxContainer,
                      }}
                    />
                  </div>
                </td>
                {orderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING && (
                  <td>
                    <div
                      className={`${classes.selectTableCont} justify-conent-center align-items-center`}
                    >
                      {!selectedTable?.id ? (
                        <Btn
                          className={`${classes.btn}`}
                          text="Choose Table"
                          onClick={() => {
                            toggleModal(true);
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <OutlinedInput
                            fullWidth
                            classes={{
                              input: classes.input,
                            }}
                            value={selectedTable.name}
                            disabled={true}
                          />
                          <Btn
                            handleClick={() => {
                              dispatch(clearTableSelection());
                            }}
                            text="Clear"
                            className={classes.loginBtn}
                          />
                        </div>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            )}
            <tr>
              <td className="w-50">
                <DateSlotPicker
                  slots={dateSlots}
                  className={`w-100 ${classes.dateTimeSelection}`}
                  onChange={onSelectDataAndTime}
                  isFromCheckout={true}
                  newChange={newChange}
                  setNewChange={setNewChange}
                />
              </td>
              <td className="w-50">
                <TimePicker
                  slots={
                    moment(value.deliveryTime).isSame(moment(), "date") &&
                    getTodayDeliveryIntervalSlots.length > 0
                      ? getTodayDeliveryIntervalSlots
                      : getDeliveryIntervalSlots
                  }
                  isFromCheckout={true}
                  date={date}
                  setTime={setTime}
                  onClick={onClick}
                  setNewChange={setNewChange}
                  className={`w-100 ${classes.dateTimeSelection}`}
                  onChange={onSelectDataAndTime}
                  typeChanges={typeChanges}
                  newChange={newChange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Modal
        customView={true}
        open={showModal}
        handleClose={() => toggleModal(false)}
      >
        <TableListing
          handleClose={() => {
            toggleModal(false);
          }}
        />
      </Modal>
    </div>
  );
};

export default DeliveryTime;
